let $ = require('jquery');
let Vue = require('vue');
let Promise = require('bluebird');

Vue.directive('uniform', {
    priority: 1000,
    params: [],
    bind: function () {
    },
    update: function (value) {
        $(this.el)
            .prop('checked', !!value);
        $(this.el).uniform();
    },
    unbind: function () {
        //$(this.el).off().select2('destroy')
    }
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/uniform.js